import { IResourceChain } from '@/interfaces/chain';

const API_PATH = 'https://chainid.network/chains.json';

export const getChainList = async (): Promise<Array<IResourceChain>> => {
  try {
    const res = await fetch(API_PATH);
    const data = await res.json();
    return data as Array<IResourceChain>;
  } catch (err: unknown) {
    return [];
  }
};
